import * as React from "react";
const SvgArrowRightIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 2.00024L11.0005 8.00024L5 14.0002", stroke: "currentColor", strokeWidth: 2 }));
export default SvgArrowRightIcon;
